// Public subcontractor-facing routes. The slugs are deliberately opaque so the
// URL doesn't reveal what the page is for. To rotate, change the values here
// and every consumer picks up the new path automatically.
//
// NOTE: obscure URLs are not a security boundary — they only hide the path
// from casual discovery. Access control still needs a real auth check on the
// backend.
export const SUBCONTRACTOR_ROUTES = {
  login: "/s/a7f3b2e1",
  retrieve: "/s/c9d8e5f4",
  form: "/s/b2e6a3d9",
};
